// axios-client-factory.ts
import axios, {AxiosInstance, AxiosRequestConfig, AxiosError} from "axios";
import AppSettings                                            from "../common/app-settings";


// Factory function for creating Axios clients
export const createAxiosClient = (
    baseUrl: string, xApiKey?: string,
    additionalBaseURL: string = "",
    headers?: Record<string, string>
): AxiosInstance => {
    const client = axios.create({
                                    baseURL: baseUrl + additionalBaseURL,
                                    headers: {
                                        "Content-Type": "application/json",
                                        "X-Api-Key"   : xApiKey || "",
                                        ...headers,
                                    },
                                    timeout: 29000, // Timeout matches API Gateway timeout
                                });

    // Add interceptors if needed
    let retryCount = 0;
    const MAX_RETRY = 3;

    client.interceptors.response.use(
        (response) => response,
        async (error: AxiosError) => {
            const shouldRetry =
                      retryCount < MAX_RETRY &&
                      error.response?.status !== 403 && // No retries for CORS errors
                      error.response?.status !== 401 && // No retries for unauthorized access
                      (
                          error.response?.status === 504 || error.code === "ERR_NETWORK"
                      );

            if (!shouldRetry) {
                console.error(`Non-retryable error or retries exceeded: ${error}`);
                retryCount = 0;
                return Promise.reject(error);
            }

            retryCount++;
            console.warn(
                `Retry attempt ${retryCount} after encountering ${error.response?.status || error.code}`
            );
            return client.request(error.config as AxiosRequestConfig);
        }
    );

    return client;
};